import { useState } from "react";
import { toast } from "sonner";
import { Youtube, Loader2 } from "lucide-react";
import { field, darkBtn } from "@/lib/adminApi";
import { ytThumb } from "@/lib/youtube";

const ID_RE = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export default function YoutubeForm({ api, themes, onDone }) {
  const [url, setUrl] = useState("");
  const [theme, setTheme] = useState("");
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const id = url.match(ID_RE)?.[1];

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/admin/media/youtube", { url, theme, caption });
      toast.success("Vidéo YouTube ajoutée à l'album.");
      setUrl("");
      setCaption("");
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Ajout impossible.");
    }
    setBusy(false);
  };

  return (
    <section data-testid="youtube-form" className="rounded-2xl border border-stone-200/80 bg-white p-5 shadow-sm">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-stone-900">
        <Youtube className="h-5 w-5 text-[#C85A32]" /> Ajouter une vidéo YouTube
      </h2>
      <div className="mt-4 flex gap-4">
        <div className="flex-1 space-y-3">
          <input data-testid="youtube-url-input" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://www.youtube.com/watch?v=…" className={field} />
          <div className="grid gap-3 sm:grid-cols-2">
            <input data-testid="youtube-theme-input" list="media-theme-list" value={theme} onChange={(e) => setTheme(e.target.value)} placeholder="Thématique" maxLength={60} className={field} />
            <input data-testid="youtube-caption-input" value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Légende (facultatif)" maxLength={140} className={field} />
          </div>
        </div>
        {id && <img data-testid="youtube-preview" src={ytThumb(id)} alt="Aperçu" className="hidden h-24 w-40 rounded-lg object-cover sm:block" />}
      </div>
      {url && !id && <p data-testid="youtube-url-error" className="mt-2 text-xs text-[#C85A32]">Ce lien ne ressemble pas à une vidéo YouTube.</p>}
      <button data-testid="youtube-submit-button" onClick={submit} disabled={busy || !id || !theme.trim()} className={`${darkBtn} mt-4 w-full py-3`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Youtube className="h-4 w-4" />} Ajouter à l'album
      </button>
    </section>
  );
}
